<div class="setupDetailWrapper">
    <div class="viewWrapper">
        <div class="setup-sectioN">
            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Source Name:</span>
                <div class="value">{{datasetData?.customerDetails?.sourceName || 'NA'}}</div>
            </div>

            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Enrollment ID:</span>
                <div class="value">{{datasetData?.customerDetails?.enrollmentId || 'NA'}}</div>
            </div>

            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Account ID:</span>
                <div class="value">{{datasetData?.customerDetails?.accountId || 'NA'}}</div>
            </div>

            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Payload Location:</span>
                <div class="value">{{datasetData?.customerDetails?.payloadLocation || 'NA'}}</div>
            </div>

            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Update Frequency:</span>
                <div class="value">{{datasetData?.customerDetails?.updateFrequency || 'NA'}}</div>
            </div>

            <div class="fieldWrapper">
                <span class="col-sm-4 col-form-label">Source Indexer Column:</span>
                <div class="value">{{datasetData?.sourceIndexer?.columns || 'NA'}}</div>
            </div>
        </div>
    </div>
    <div class="source-dataset-grid">
        <h2 class="heighlight">Data Mapping</h2>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Column Headers</th>
                    <th>Select Data Type</th>
                    <th>Input length of field</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of dataetTable ">
                    <td>{{ item[0] }}</td>
                    <td>{{ item[1][0] }}</td>
                    <td>{{ item[1][1] }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>